import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   */
  fetchUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/facility/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list for export
   */
  fetchUsersExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/facility/v1/users/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Single user
   */
  fetchUser: (id: string): Promise<any> =>
    getRequest(`${config.accountApiUrl}api/facility/v1/users/${id}`),
  /**
   * Fetch the Single user
   */
  fetchUserActivityLogs: (id: string): Promise<any> =>
    getRequest(`${config.notificationApiUrl}api/facility/v1/general-log/activityLog/${id}`),
  /**
   * Create the user api call function
   * @param data
   * @returns
   */
  createUser: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.accountApiUrl}api/facility/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Update the user api call function
   * @param data
   * @returns
   */
  editUser: (id: string, data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.accountApiUrl}api/facility/v1/users/${id}`, {
      ...parameters,
    });
  },
  /**
   * Update the user profile image
   * @param data
   * @returns
   */
  editUserProfileImage: (data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(
      `${config.accountApiUrl}api/facility/v1/users/profile-image`,
      {
        ...parameters,
      },
      true,
    );
  },
  /**
   * Update the user government id
   * @param data
   * @returns
   */
  editUserGovernmentId: (data: any): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(
      `${config.accountApiUrl}api/facility/v1/users/government-id`,
      {
        ...parameters,
      },
      true,
    );
  },
  /**
   * Delete the user api call function
   * @param data
   * @returns
   */
  deleteUser: (id: String): Promise<any> => {
    return deleteRequest(`${config.accountApiUrl}api/facility/v1/users/${id}`);
  },

  /**
   * Fetch user API
   * @returns 
   */
  fetchListFilters: () => {
    return getRequest(`${config.accountApiUrl}api/facility/v1/users/list-filters`);
  },
  

};
